import React from 'react';

const AuthRootComponent = ({ children }) => {
  return (
    <div className="hasBGLogin">
      <div className="flex items-center justify-center min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default AuthRootComponent;
